import React, { useEffect } from "react";
import { AppProps as NextAppProps } from "next/app";
import {
  Components,
  StoryblokProvider,
  GlobalStoryblok,
  PageStoryblok,
} from "@cancer-council-queensland/storyblok";

// analytics
import { GoogleAnalyticsProvider } from "@cancer-council-queensland/google-analytics";
import TagManager from "react-gtm-module";

// nprogress
import Router, { useRouter } from "next/router";
import NProgress from "nprogress";

// import styles
import "nprogress/nprogress.css";
import "katex/dist/katex.min.css";
import "react-phone-input-2/lib/style.css";
import "../styles/globals.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

// binding events
Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

const gtmId = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID;
const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export interface Props {
  pageComponents: GlobalStoryblok;
  page: PageStoryblok;
  preview: boolean;
  redirect?: string | null;
}

type AppProps<P = any> = {
  pageProps: P;
} & Omit<NextAppProps<P>, "pageProps">;

const App = ({ Component, pageProps }: AppProps<Props>) => {
  const router = useRouter();

  let variant = process.env.NEXT_PUBLIC_VARIANT!;

  if (!variant) {
    const slug = router.asPath
      .split("?")[0]
      .split("/")
      .filter((v) => v);
    if (slug.length) variant = slug[0];
    else variant = "common";
  }

  useEffect(() => {
    if (gtmId) {
      TagManager.initialize({ gtmId });
    }
  }, []);

  useEffect(() => {
    document.body.classList?.remove("loading");
    document.body.setAttribute("data-theme", variant);
  }, [variant]);

  return (
    <GoogleAnalyticsProvider measurementId={measurementId}>
      <StoryblokProvider value={Components}>
        <Component {...pageProps} key={router.asPath} />
      </StoryblokProvider>
    </GoogleAnalyticsProvider>
  );
};

export default App;
